<template>
    <span>
        <button class="uk-button-small primary uk-modal-close" @click="clicked">Place</button>
    </span>
</template>

<script>
    import EventBus from "../../events.js";
    export default {
        name: "PlaceButton",

        components:{
            EventBus
        },

        props:{
            cell_data:{type:Object}
        },

        data(){
            return {

            };
        },

        methods:{
            clicked(){
                EventBus.fireEvent("placement-chosen", this.cell_data.id);
            }
        }
    }
</script>
